var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAvsender = function SvgAvsender(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m8 8.475 6.468 2.845V20l-5.747-2.332c-.436-.176-.721-.6-.721-1.07zm15-.332-.11 7.88a1.155 1.155 0 0 1-.728 1.057l-7.307 2.91v-8.675zm-6.252-3.037 5.954 2.744-8.043 3.135-6.362-2.799 7.528-3.099c.297-.122.631-.115.923.02",
    className: "Avsender_svg__FlowIcon"
  }), /*#__PURE__*/React.createElement("g", {
    className: "Avsender_svg__flowIconSnowStorm"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m13.802 6 5.585 2.744.498.61-1.317.514 1.134-.441v2.407l-2.028.816v-2.434l.007-.003-.566-.579-5.63-2.693zM9.873 12.34l2.598 1.049a.21.21 0 0 1 .131.194v3.636a.21.21 0 0 1-.288.195l-2.597-1.05a.21.21 0 0 1-.131-.194l-.002-3.636a.21.21 0 0 1 .29-.195"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m11.846 16.273.154.054V17l-.154-.057zm-.405-.147.154.052v.675l-.154-.057zm-.666-.241.193.071v.672l-.193-.07zm-.38-.136.225.082v.672l-.226-.081zM10 15.607l.304.108v.673L10 16.28zM10 15l.304.108v.371L10 15.37zM6.5 16a.5.5 0 1 1 0 1h-5a.5.5 0 1 1 0-1zm0-4a.5.5 0 1 1 0 1h-3a.5.5 0 1 1 0-1zm0-4a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1z",
    className: "Avsender_svg__flowIconPrimary"
  }))));
};
export default SvgAvsender;